import { MESSAGE_COMPONENT_TYPE } from "../enums";
import { FormFooterComponent, FormHeaderComponent, FormItemComponent } from "./forms";

/**
 * Interface for message structure component.
 *
 * SD-5939: New properties added to handle form components inside a modal.
 *
 * @lastmodifiedBy PM
 * @lastmodifiedDate 2024-10-15 (YYYY-MM-DD)
 */
export type MessageStructureComponent = {
    type: MESSAGE_COMPONENT_TYPE;
    content?: string;
    imageUrl?: string;
    alt?: string;
    clickAction?: {
        type?: string,
        url?: string,
        postback?: string,
        postbackAction?: string,
        replyText?: string,
        settings: {
            browserTarget?: string,
            browserTargetDesktop?: string,
            browserTargetMobile?: string,
            hideInChatBackButton?: boolean,
            showReplyText?: boolean,
            passUserLocation?: boolean
        },
        metadata?: any
        property?: string,
        propertyValue?: number | string
    };
    style?: {
        type?: string;
        size?: string;
        width?: any;
        height?: any;
    };
    label?: string;
    metadata?: any;
    settings?: {
        disableHideOnSend?: boolean
    };
    name?: string;
    placeholder?: string;
    rows?: number;
    maxLength?: number;
    templateName?: string;
    formHeader?: FormHeaderComponent[];
    formItems?: FormItemComponent[];
    formFooter?: FormFooterComponent[];
    originalTime?: Date;
}
